import moment from 'moment';
import { getAppLanguageCode, getMomentLocale, isEnglishLanguage as isEn } from './appLocale';

const MONTH_CODES = {
  ene: 0,
  feb: 1,
  mar: 2,
  abr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  ago: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dic: 11,
};

export function isEnglishLanguage(language) {
  return isEn(language);
}

export function formatDashboardMonthCode(monthCode, language) {
  const code = (monthCode || '').toLowerCase();
  const idx = MONTH_CODES[code];
  if (idx === undefined) return (monthCode || '').toUpperCase();
  return moment().locale(getMomentLocale(language)).month(idx).format('MMM').replace(/\./g, '').toUpperCase();
}

export function formatDashboardLabelPeriod(label, language) {
  if (!label || label === '000-yyyy') return '';
  const [monthCode, year] = label.split('-');
  const month = formatDashboardMonthCode(monthCode, language);
  return year && year !== 'yyyy' ? `${month} ${year}` : month;
}

export function formatPercentValue(value, language) {
  const fixed = Number(value).toFixed(1);
  return getAppLanguageCode(language) === 'es' ? fixed.replace('.', ',') : fixed;
}
